import { Button } from '@brain/ui'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Mic } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LiveResumeBanner } from '../../components/live/LiveResumeBanner.tsx'
import { MeetingList } from '../../components/meetings/MeetingList.tsx'
import { openLiveStart } from '../../lib/ui-state.ts'

export const Route = createFileRoute('/_app/meetings/')({ component: MeetingsPage })

function MeetingsPage() {
  const { t } = useTranslation()
  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex max-w-3xl flex-col gap-4 px-4 py-4 md:px-8 md:py-6">
        <header data-tauri-drag-region className="flex items-center gap-3">
          <h1 className="flex-1 text-[22px] text-text-1">{t('nav.meetings')}</h1>
          <Link to="/entscheidungen" className="font-medium text-[13px] text-pop-fg">
            {t('nav.decisions')}
          </Link>
          <Button size={32} onClick={() => openLiveStart()}>
            <Mic size={15} strokeWidth={1.9} />
            {t('live.start')}
          </Button>
        </header>
        <p className="text-[13px] text-text-2">{t('meetings.intro')}</p>
        <LiveResumeBanner />
        <MeetingList />
      </div>
    </div>
  )
}
